import { getPercent } from '@/shared/lib/getPercent';
import { Status } from '@/shared/types/Status';

import {
  DETERMINING_SPEAKERS_SEC,
  DETERMINING_SPEAKERS_TO_VOICE_SUGGEST_SEC,
  PROJECT_CREATED_TO_UPLOADING_SEC,
  SEPARATE_BACKGROUND_SEC,
  SEPARATE_BACKGROUND_TO_DETERMINING_SPEAKERS_SEC,
  TRANSLATION_SEC,
  VIDEO_UPLOADED_TO_SEPARATE_BACKGROUND_SEC,
  VIDEO_UPLOADING_SEC,
  VOICE_SUGGESTING_SEC,
  VOICE_SUGGESTING_TO_TRANSLATION_SEC,
} from './mlAverageTasksDurations';

export const SRC_SRT_UPLOADING_SEC_FOR_60_SEC_VIDEO =
  PROJECT_CREATED_TO_UPLOADING_SEC +
  VIDEO_UPLOADING_SEC +
  VIDEO_UPLOADED_TO_SEPARATE_BACKGROUND_SEC +
  SEPARATE_BACKGROUND_SEC +
  SEPARATE_BACKGROUND_TO_DETERMINING_SPEAKERS_SEC +
  DETERMINING_SPEAKERS_SEC +
  DETERMINING_SPEAKERS_TO_VOICE_SUGGEST_SEC +
  VOICE_SUGGESTING_SEC +
  VOICE_SUGGESTING_TO_TRANSLATION_SEC +
  TRANSLATION_SEC;

const INITIAL_PERCENT = 1;
const FINAL_PERCENT = 99;

// Calculated initial percentages for each SRT upload status
const DETERMINE_SPEAKERS_TO_VOICE_SUGGEST_INITIAL_PERCENT = getPercent(
  PROJECT_CREATED_TO_UPLOADING_SEC +
    VIDEO_UPLOADING_SEC +
    VIDEO_UPLOADED_TO_SEPARATE_BACKGROUND_SEC +
    SEPARATE_BACKGROUND_SEC +
    SEPARATE_BACKGROUND_TO_DETERMINING_SPEAKERS_SEC +
    DETERMINING_SPEAKERS_SEC,
  SRC_SRT_UPLOADING_SEC_FOR_60_SEC_VIDEO,
);
const VOICE_SUGGEST_INITIAL_PERCENT = getPercent(
  PROJECT_CREATED_TO_UPLOADING_SEC +
    VIDEO_UPLOADING_SEC +
    VIDEO_UPLOADED_TO_SEPARATE_BACKGROUND_SEC +
    SEPARATE_BACKGROUND_SEC +
    SEPARATE_BACKGROUND_TO_DETERMINING_SPEAKERS_SEC +
    DETERMINING_SPEAKERS_SEC +
    DETERMINING_SPEAKERS_TO_VOICE_SUGGEST_SEC,
  SRC_SRT_UPLOADING_SEC_FOR_60_SEC_VIDEO,
);
const VOICE_SUGGEST_TO_TRANSLATION_INITIAL_PERCENT = getPercent(
  PROJECT_CREATED_TO_UPLOADING_SEC +
    VIDEO_UPLOADING_SEC +
    VIDEO_UPLOADED_TO_SEPARATE_BACKGROUND_SEC +
    SEPARATE_BACKGROUND_SEC +
    SEPARATE_BACKGROUND_TO_DETERMINING_SPEAKERS_SEC +
    DETERMINING_SPEAKERS_SEC +
    DETERMINING_SPEAKERS_TO_VOICE_SUGGEST_SEC +
    VOICE_SUGGESTING_SEC,
  SRC_SRT_UPLOADING_SEC_FOR_60_SEC_VIDEO,
);
const TRANSLATION_INITIAL_PERCENT = getPercent(
  PROJECT_CREATED_TO_UPLOADING_SEC +
    VIDEO_UPLOADING_SEC +
    VIDEO_UPLOADED_TO_SEPARATE_BACKGROUND_SEC +
    SEPARATE_BACKGROUND_SEC +
    SEPARATE_BACKGROUND_TO_DETERMINING_SPEAKERS_SEC +
    DETERMINING_SPEAKERS_SEC +
    DETERMINING_SPEAKERS_TO_VOICE_SUGGEST_SEC +
    VOICE_SUGGESTING_SEC +
    VOICE_SUGGESTING_TO_TRANSLATION_SEC,
  SRC_SRT_UPLOADING_SEC_FOR_60_SEC_VIDEO,
);
// Константы для загрузки видео
export const SRC_SRT_UPLOADING_TASKS_SEC: {
  [key in Status]?: number;
} = {
  [Status.determineSpeakersDone]: DETERMINING_SPEAKERS_TO_VOICE_SUGGEST_SEC,
  [Status.determineSpeakersStarted]: DETERMINING_SPEAKERS_SEC,
  [Status.translationStarted]: TRANSLATION_SEC,
  [Status.voiceSuggestDone]: VOICE_SUGGESTING_TO_TRANSLATION_SEC,
  [Status.voiceSuggestStarted]: VOICE_SUGGESTING_SEC,
};
export const INITIAL_PERCENT_FOR_SRC_SRT_UPLOADING_STATUS: {
  [key in Status]?: number;
} = {
  [Status.determineSpeakersDone]: DETERMINE_SPEAKERS_TO_VOICE_SUGGEST_INITIAL_PERCENT,
  [Status.determineSpeakersStarted]: INITIAL_PERCENT,
  [Status.translationStarted]: TRANSLATION_INITIAL_PERCENT, // 92
  [Status.voiceSuggestDone]: VOICE_SUGGEST_TO_TRANSLATION_INITIAL_PERCENT,
  [Status.voiceSuggestStarted]: VOICE_SUGGEST_INITIAL_PERCENT,
};
export const FINAL_PERCENT_FOR_SRC_SRT_UPLOADING_STATUS: {
  [key in Status]?: number;
} = {
  [Status.determineSpeakersDone]: VOICE_SUGGEST_INITIAL_PERCENT,
  [Status.determineSpeakersStarted]: DETERMINE_SPEAKERS_TO_VOICE_SUGGEST_INITIAL_PERCENT,
  [Status.translationStarted]: FINAL_PERCENT, // 99
  [Status.voiceSuggestDone]: TRANSLATION_INITIAL_PERCENT,
  [Status.voiceSuggestStarted]: VOICE_SUGGEST_TO_TRANSLATION_INITIAL_PERCENT,
};
